// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ItemList_itemList__a1Jrq","title":"ItemList_title__234So","items":"ItemList_items__1PDHI"};